import WorkspacesPage from './container';

export default WorkspacesPage;
